/*
* Copyright (c) 2023 Eugenio Espinoza
*/

import React from 'react';
import './AboutPage.css';

const PILLARS = [
  { k: 'Lealtad', body: 'A nuestros artistas, a nuestro oficio, a las historias que decidimos contar.' },
  { k: 'Constancia', body: 'Trabajo disciplinado — en estudio, en carretera, en cada decisión creativa.' },
  { k: 'Integridad', body: 'Contratos claros, relaciones largas, respeto por la obra y por quien la hace.' },
  { k: 'Perseverancia', body: 'Una carrera no se construye en un sencillo. Se construye con paciencia.' },
];

const FOUNDERS = [
  { name: 'José Luis Maldonado', role: 'Co-founder · CEO', alias: 'C-Kan' },
  { name: 'José Acevedo', role: 'Co-founder · Operations', alias: 'Joe' },
  { name: 'Jesús Castro', role: 'Co-founder · A&R', alias: 'Homie' },
];

const STATS = [
  { v: '10+', k: 'Años en la industria' },
  { v: '6', k: 'Artistas firmados' },
  { v: '200M+', k: 'Streams globales' },
  { v: '15', k: 'Países en tour' },
];

function AboutPage() {
  return (
    <div className="mt-about">
      {/* Manifesto split */}
      <section className="mt-about__manifesto">
        <div className="mt-container mt-about__manifestoInner">
          <aside className="mt-about__label">
            <span className="mt-kicker">Una carta</span>
            <p>N° 01 · Mastered Trax<br/>Guadalajara · Chicago · Est. 2014</p>
          </aside>
          <div className="mt-about__copy">
            <p className="mt-about__lede">
              <span>Mastered Trax</span> es un sello discográfico independiente, experto en la
              representación y desarrollo de artistas — poniendo a su disposición relaciones y
              experiencia para el crecimiento de cualquier proyecto musical.
            </p>
            <p>
              Nuestro objetivo es llevar la música a otro nivel — cruzando barreras de género,
              idioma y geografía. Actualmente trabajamos con proyectos de <em>Hip-Hop, Regional
              Mexicano y R&amp;B / Urbano</em>. La casa fue fundada en 2014 por José Luis
              Maldonado "C-Kan", José "Joe" Acevedo y Jesús "Homie" Castro, quienes en conjunto
              con la familia que hoy conforma esta compañía, tienen la capacidad para llevar a
              cabo el éxito con cada uno de sus artistas.
            </p>
            <p>
              Estamos comprometidos a producir material de calidad y excelencia — aplicando los
              valores que nos identifican: lealtad, constancia, integridad y perseverancia.
            </p>
          </div>
        </div>
      </section>

      {/* Stats strip */}
      <section className="mt-about__stats">
        <div className="mt-container mt-about__statsGrid">
          {STATS.map((s) => (
            <div key={s.k} className="mt-about__stat">
              <span className="mt-about__statValue">{s.v}</span>
              <span className="mt-about__statKey">{s.k}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Pillars / values */}
      <section className="mt-about__pillars">
        <div className="mt-container mt-about__pillarsInner">
          <div className="mt-about__pillarsHead">
            <span className="mt-eyebrow">Our Values · Cuatro principios</span>
            <h2>
              Cómo trabajamos<br/>
              <em>y por qué.</em>
            </h2>
          </div>
          <ul className="mt-about__pillarsList">
            {PILLARS.map((p, i) => (
              <li key={p.k} className="mt-about__pillar">
                <span className="mt-about__pillarNum">0{i + 1}</span>
                <h3>{p.k}</h3>
                <p>{p.body}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* Founders */}
      <section className="mt-about__founders">
        <div className="mt-container mt-about__foundersInner">
          <div className="mt-about__foundersHead">
            <span className="mt-eyebrow">Founders · Est. 2014</span>
            <h2>Tres firmas. <em>Una casa.</em></h2>
          </div>
          <ul className="mt-about__foundersList">
            {FOUNDERS.map((f, i) => (
              <li key={f.name} className="mt-about__founder">
                <span className="mt-about__founderIndex">F-0{i + 1}</span>
                <div>
                  <h3>{f.name}</h3>
                  <p>{f.role} · <em>"{f.alias}"</em></p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* Closing quote */}
      <section className="mt-about__quote">
        <div className="mt-container">
          <blockquote>
            <span>"</span>
            No es un trabajo — es la obra que elegimos cuidar.
            <cite>The Mastered Trax Ethos</cite>
          </blockquote>
        </div>
      </section>
    </div>
  );
}

export default AboutPage;
